export default {
  // iStoreUrl: 'https://octonrd01.starise.network/istore',
  // iStoreUrl: 'https://210.59.192.123:1443/istore',
  // iStoreUrl: 'https://192.168.1.19/istore',
  iStoreUrl: 'http://localhost:5001/istore',
  iStoreSTT: 'https://192.168.0.99/sttqueue',
  iStoreCloud: 'https://rdcloud.starise.network/istore',
  activityCheckInterval: 60000 * 15,
  waterMarkingId: null,
}
